import {Axios, RestAxios} from '../utils/Axios'

const {get, post} = Axios

/**
 * 客户用户-密码登录
 */
export const loginForPassword = (username, password) => {
  return Axios.post('web/user/customer-users/login/password', {
    username: username,
    password: password
  })
}
// /****
//  商品收藏
//  */
// export const productFind = () => {
//   return Axios.get('/product/find')
// }

/****
 商品删除
 */
export const productDelete = (id) => {
  return Axios.delete(`/product/delete/${id}`)
}

// /***
//  商品评论
//  */
// export const productReview = (page, size) => {
//   return Axios.get('/product/review', {
//     params: {
//       page: page,
//       size: size,
//     }
//   })
// }

/****
 商品评论删除
 */
export const reviewDelete = (id) => {
  return Axios.delete(`/product/delete-review/${id}`)
}

// /***
//  商品咨询
//  */
// export const productConsultation = (page, size) => {
//   return Axios.get('/product/consultation', {
//     params: {
//       page: page,
//       size: size,
//     }
//   })
// }

/****
 商品咨询删除
 */
export const consultationDelete = (id) => {
  return Axios.delete(`/product/delete-consultation/${id}`)
}
/**
 * 客户用户-短信登录（商城）
 */
export const loginForPassword1 = (id) => {
  return Axios.post('/web/user/customer-users/login/shop',[id])
}

/**
 * 绑定优惠券
 */
export const bind = (code) => {
  return Axios.get( `/shop/bindingCoupon?code=${code}`)
}
/**
 * 我的优惠券
 */
export const mycoupon = (use) => {
  return Axios.get(`/shop/list?use=${use}`,)
}


/**
 * 短信登录
 * @param mobile
 * @param code
 * @param rememberMe
 */
export const loginForSms = (mobile, code, rememberMe) => {
  return Axios.post('web/user/customer-users/login/sms', {
    mobile: mobile,
    code: code,
    rememberMe: rememberMe
  })
}

/**
 * 短信验证码
 * @param mobile
 */
export const smsSend = (mobile) => {
  return Axios.get(`sms/send/${mobile}`)
}

/**
 * 邮箱验证码发送
 * @param email
 */
export const emailCode = (email) => {
  return Axios.get('email-records/send-code', {
    params: {
      email: email
    }
  })
}

/**
 * 密码修改
 * @param oldPassword
 * @param newPassword
 * @param enterPassword
 */
export const changePassword = (oldPassword, newPassword, enterPassword) => {
  return Axios.put('web/user/customer-users/change-password', {
    oldPassword: oldPassword,
    newPassword: newPassword,
    enterPassword: enterPassword
  })
}

/**
 * 重置密码
 * @param username
 * @param code
 * @param newPassword
 * @param enterPassword
 */
export const resetPassword = (username, code, newPassword, enterPassword) => {
  return Axios.put('web/user/customer-users/reset-password', {
    username: username,
    code: code,
    newPassword: newPassword,
    enterPassword: enterPassword
  })
}

/**
 * 客户用户-注册
 * @param code
 * @param province
 * @param provinceCode
 * @param city
 * @param cityCode
 * @param county
 * @param detail
 * @param email
 * @param enterPassword
 * @param mobile
 * @param password
 * @param realName
 * @param workUnitName
 * @param remarks
 */
export const register = (code, province, provinceCode, city, cityCode, detail, email, enterPassword, mobile, password, realName, workUnitName, remarks) => {
  return Axios.post(`web/user/customer-users/register?code=${code}`, {
    deliveryAddress: {
      province: province,
      provinceCode: provinceCode,
      city: city,
      cityCode: cityCode,
      detail: detail
    },
    email: email,
    enterPassword: enterPassword,
    mobile: mobile,
    password: password,
    realName: realName,
    workUnitName: workUnitName,
    remarks: remarks
  })
}

/**
 * 客户用户-详情
 */
export const customerUsers = () => {
  return Axios.get('web/user/customer-users/self')
}

/**
 * 手机号修改
 */
export const changeMobile = (mobile, code) => {
  return Axios.put('web/user/customer-users/change-mobile', {
    mobile: mobile,
    code: code
  })
}

/**
 * 姓名修改
 * @param realName
 */
export const changeRealName = (realName) => {
  return Axios.put('web/user/customer-users/change-real-name', {
    realName: realName
  })
}
/**
 * 邮箱修改
 * @param email
 * @param code
 */
export const changeEmail = (email, code) => {
  return Axios.put('web/user/customer-users/change-email', {
    email: email,
    code: code
  })
}

/**
 * 地址修改
 */
export const changeAddress = (address = {}) => Axios.put('web/user/customer-users/change-address', address)

/**
 * 抄送邮箱修改
 * @param copyEmails
 */
export const changeCopyEmails = (copyEmails) => {
  return Axios.put('web/user/customer-users/change-copy-emails', {
    copyEmails: copyEmails
  })
}

/**
 * 课题组-详情
 */
export const customerGroupsDetail = (id) => {
  return Axios.get(`web/user/customer-research-groups/${id}`)
}

/**
 * 课题组-成员授权
 */
export const changeAuthorizeState = id => Axios.put(`web/user/customer-users/authorization?id=${id}`)

/**
 * 资源中心栏目-分页
 */
export const resourceColumns = () => {
  return Axios.get('web/cms/resource-center-columns')
}
/**
 * 资源中心-分类
 */
 export const classifications = (params) => {  
  // return Axios.get('/resource-center-classifications',{
  return Axios.get('/resource-center-classifications/query',{
    params
  })
}
/**
 * 资源下载内容-分页
 */
// export const resourceDownloads = (id, page, size,classificationId) => {
//   return Axios.get('web/cms/resource-center-contents', {
//     params: {
//       'resourceCenterId.equals': id,
//       'classificationId.equals': classificationId,
//       page: page,
//       size: size
//     }
//   })
// }
export const resourceDownloads = (params) => {
  return Axios.get('web/cms/resource-center-contents', {
    params
  })
}

/**
 * 新闻栏目-分页
 */
export const newsColumns = () => {
  return Axios.get('web/cms/news-columns')
}

/**
 * 新闻资讯-分页
 */
export const newsInformation = (id, page, size) => {
  return Axios.get('web/cms/news-informations', {
    params: {
      'newsColumnId.equals': id,
      page: page,
      size: size
    }
  })
}

/**
 * 营销内容-分页
 */
export const marketContents1 = ( page, size) => {
  return Axios.get('web/cms/marketing-contents', {
    params: {
      page: page,
      size: size
    }
  })
}

/**
 * 营销内容-详情
 * @param id
 */
export const marketContents = (id) => {
  return Axios.get(`web/cms/marketing-contents/${id}`)
}

/**
 * 新闻资讯-详情
 * @param id
 */
export const newsDetails = (id) => {
  return Axios.get(`web/cms/news-informations/${id}`)
}

/**
 * 招聘地点-分页
 */
export const recruitLocations = () => {
  return Axios.get('web/cms/recruit-locations/select')
}

/**
 * 招聘岗位-分页
 */
export const recruitJobs = (id, page, size) => {
  return Axios.get('web/cms/recruit-location-jobs', {
    params: {
      locationId: id,
      page: page,
      size: size
    }
  })
}

/**
 * 基因图谱-分页
 */
export const geneCarrierMaps = () => {
  return Axios.get('web/cms/gene-carrier-maps')
}

/**
 * geneMaps
 * @param goalCarrier
 */
export const geneMaps = (goalCarrier) => {
  return Axios.get('web/cms/gene-carrier-maps/goal-carrier', {
    params: {
      goalCarrier: goalCarrier
    }
  })
}

/**
 * 产品中心轮播-分页
 */
export const productCenterCarousels = () => {
  return Axios.get('web/cms/product-center-carousels')
}

/**
 * 首页轮播图-分页
 */
export const homePageCarousels = () => {
  return Axios.get('web/cms/home-page-carousels')
}

/**
 * 产品中心轮播-分页
 */
export const productsCarousels = () => {
  return Axios.get('web/cms/product-center-carousels')
}

/**
 * 市场活动栏目
 */
export const marketCarousels = () => {
  return Axios.get('web/cms/market-activity-columns')
}

/**
 * 商品分类查询
 * @param name
 * @param level
 * @param parentId
 * @param page
 * @param size
 * @param sort
 */
export const productCategories = (name, level, parentId, page, size, sort) => {
  return Axios.get('web/product/categories', {
    params: {
      name: name,
      level: level,
      parentId: parentId,
      page: page,
      size: size,
      sort: 'showOrder,desc'
    }
  })
}

/**
 * 商品查询
 */
export const productGoods = (categoryIds, page, size, searchName, onSale, sort) => {
  return Axios.get('web/product/goods', {
    params: {
      categoryIds: categoryIds,
      searchName: searchName,
      onSale: onSale,
      page: page,
      size: size,
      sort: sort
    }
  })
}

/**
 * 商品详细
 * @param id
 */
export const productGoodsDetail = (id) => {
  return Axios.get(`web/product/goods/${id}`)
}

/**
 * 商品浏览记录
 * @param page
 * @param size
 */
export const browsingHistories = (page, size) => {
  return Axios.get('web/product/goods/browsing-histories', {
    params: {
      page: page,
      size: size
    }
  })
}

/**
 * 购物车新建
 * @param skuId
 * @param quantity
 */
export const createCarts = (skuId, quantity) => {
  return Axios.post('web/carts', {
    skuId: skuId,
    quantity: quantity
  })
}

/**
 * 购物车查询
 * @param expired
 */
export const carts = (expired) => {
  return Axios.get('web/carts', {
    params: {
      expired: expired
    }
  })
}

export const carts1 = () => {
  return Axios.get( 'web/shop/get_current', )
}

/**
 * 购物车更新数量
 * @param id
 */
export const updateCarts = (id, quantity) => {
  return Axios.put(`web/carts/${id}`, {
    quantity: quantity
  })
}

/**
 * 购物车批量删除
 * @param cartIds 多个用逗号分隔
 */
export const deleteCarts = (cartIds) => {
  return Axios.delete('web/carts', {
    params: {
      cartIds: cartIds
    }
  })
}

export const deleteCarts1 = (skuId) => {
  return Axios.post(  `web/shop/remove?skuid=${skuId}`, )
}

/**
 * 订单新建
 */
export const createProductOrders = (data) => {
  return Axios.post('web/product/orders', data)
}

export const createProductOrders1 = (data) => {
  return Axios.post('web/product/shopOrders', data)
}

/**
 * 订单查询 订单状态  CANCEL :取消
 NEED_AUDITING :待审核
 NEED_SEND :未发货
 PARTIAL_SEND :部分发货
 ALL_SEND :全部发货
 FINISHED :已完成
 */
export const productOrders = (page, size, orderCode, createDateStart, createDateEnd, status, customerId) => {
  return Axios.get('web/product/orders', {
    params: {
      page: page,
      size: size,
      orderCode: orderCode,
      createDateStart: createDateStart,
      createDateEnd: createDateEnd,
      webStatus: status,
      customerId: customerId
    }
  })
}

/**
 * 订单删除
 * @param id
 */
export const deleteProductOrders = (id) => {
  return Axios.delete(`web/product/orders/${id}`)
}

/**
 * 订单详情
 * @param id
 */
export const prodcutOrdersDetail = (id, customerId) => {
  return Axios.get(`web/product/orders/${id}`, {
    params: {
      customerId: customerId
    }
  })
}

/**
 * 订单发货
 * @param orderId
 * @param item object [] 发货明细
 */
export const productOrdersSend = (orderId, item) => {
  return Axios.post(`web/product/orders/${orderId}/send`, {
    item: item
  })
}


/**
 * 订单取消
 */
export const productOrderscancel = (orderId) => {
  return Axios.post(`web/product/orders/${orderId}/cancel`)
}

// 订单确认
export const productOrdersConfirm = (orderId) => {
  return Axios.post(`web/product/orders/${orderId}/confirm`)
}

/**
 * 商品查询
 */
export const pointsGoods = (page, size) => {
  return Axios.get('web/points/goods', {
    params: {
      page: page,
      size: size
    }
  })
}

/**
 * 商品详细
 */
export const pointsGoodsDetail = (id) => {
  return Axios.get(`web/points/goods/${id}`)
}

/**
 * 积分订单新建
 * @param goodsId
 * @param address
 */
export const createPointsOrders = (goodsId, address) => {
  return Axios.post('web/points/orders', {
    goodsId: goodsId,
    address: address
  })
}

/**
 * 积分订单查询
 * @param status
 * @param page
 * @param size
 */
export const pointsOrders = (status, page, size) => {
  return Axios.get('web/points/orders', {
    params: {
      status: status,
      page: page,
      size: size,
      sort: 'createTime,desc'
    }
  })
}

/**
 * 积分汇总
 */
export const customerPoints = () => {
  return Axios.get('web/points/customer-points')
}

/**
 * 积分明细
 */
export const pointsLogs = (page, size) => {
  return Axios.get('web/points/points-logs', {
    params: {
      page: page,
      size: size
    }
  })
}

/**
 * 获取 引物配置信息
 * @param key
 * @returns {Promise<AxiosResponse<any>>}
 */
export const primerConfig = (key) => {
  return RestAxios.get('primer-order/config-list', {
    params: {
      key: key
    }
  })
}

/**
 * 获取引物报价
 * @returns {Promise<AxiosResponse<any>>}
//  */
export const primerPrice = (data) => {
  return RestAxios.post(`/user-web/primer-price`, data)
}

/**
 * 引物订单新增
 * @param data
 */
export const primerOrder = (data) => {
  return RestAxios.post('user-web/primer-order', data)
}

/**
 * 引物订单编辑
 * @param id
 * @param data
 */
export const primerOrderEidt = (id, data) => {
  return RestAxios.put(`user-web/primer-order/${id}`, data)
}

/**
 * 引物订单保存提交
 * @param id
 * @param data
 */
export const primerOrderSubmit = (id, data) => {
  return RestAxios.put(`/user-web/primer-orders/${id}/submit`, data)
}
/**
 * 校验当前登录用户是否被拉黑
 */
export const checkBlackList = (params) => {
  return Axios.get('service-blacklists/check', {
    params
  })
}

/**
 * 引物订单列表
 * @param page
 * @param size
 * @param orderId
 * @param createDayStart
 * @param createDayEnd
 * @param userWebOrderStatus
 */
export const primer = (page, size, orderId, createDayStart, createDayEnd, userWebOrderStatus, customerId, researchTeamId, customerRemark) => {
  return RestAxios.get('user-web/primer-order', {
    params: {
      page: page,
      size: size,
      no: orderId,
      createDayStart: createDayStart,
      createDayEnd: createDayEnd,
      userWebOrderStatus: userWebOrderStatus,
      customerId: customerId,
      researchTeamId: researchTeamId,
      sort: 'createTime,desc',
      // showCoreOrderFlag: true,
      mainOrderFlag: true,
      customerRemark,
    }
  })
}

/**
 * 引物详情
 */
export const primerOrderDetail = (id) => {
  return RestAxios.get(`user-web/primer-order/${id}`)
}

/**
 * 引物详情-引物信息
 * @param id
 */
export const primerInfo = (id, page, size) => {
  return RestAxios.get(`user-web/primer-order/${id}/primers`, {
    params: {
      page: page,
      size: size
    }
  })
}

/**
 * 查询项目
 */
export const project = (page, size, orderNo, createDayStart, createDayEnd, userWebOrderStatus, customerId, researchTeamId) => {
  return RestAxios.get('user-web/project', {
    params: {
      page: page,
      size: size,
      no: orderNo,
      createDayStart: createDayStart,
      createDayEnd: createDayEnd,
      userWebOrderStatus: userWebOrderStatus,
      customerId: customerId,
      researchTeamId: researchTeamId,
      sort: 'createTime,desc'
    }
  })
}

/**
 * 项目订单详情
 * @param id
 */
export const projectDetail = (id) => {
  return RestAxios.get(`user-web/project/${id}`)
}

/**
 * 测序订单-查询分页
 */
export const sequencingOrders = (page, size, orderId, createDayStart, createDayEnd, endTimeStart, endTimeEnd, status, customerId, researchTeamId,customerRemark, resultDownloadStatus) => {
  return RestAxios.get('user-web/sequencing-orders', {
    params: {
      page: page,
      size: size,
      no: orderId,
      createDayStart: createDayStart,
      createDayEnd: createDayEnd,
      endTimeStart,
      endTimeEnd,
      userWebOrderStatus: status,
      customerId: customerId,
      researchTeamId: researchTeamId,
      sort: 'createTime,desc',
      customerRemark,
      resultDownloadStatus,
    }
  })
}

/**
 * 高通量订单-查询分页
 */
 export const highOrders = (page, size, orderId, createDayStart, createDayEnd, status, customerId, researchTeamId,customerRemark) => {
  return RestAxios.get('user-web/high-throughput-orders', {
    params: {
      page: page,
      size: size,
      no: orderId,
      createDayStart: createDayStart,
      createDayEnd: createDayEnd,
      userWebOrderStatus: status,
      customerId: customerId,
      researchTeamId: researchTeamId,
      sort: 'createTime,desc',
      customerRemark:customerRemark
    }
  })
}
/**
 * 核心系统-官网-测序
 * @param id
 */
export const sequencingOrdersDetails = (id) => {
  return RestAxios.get(`user-web/sequencing-orders/${id}`)
}
/**
 * 核心系统-官网-高通量
 * @param id
 */
 export const highThroughputOrders = (id) => {
  return RestAxios.get(`user-web/high-throughput-orders/${id}`)
}

/**
 * 测序订单-反应信息
 * @param id
 */
export const sequencingReaction = (id, page, size, demoName, primerName, officialDownloadResultFlag, firstResultUploadTimeStart, firstResultUploadTimeEnd) => {
  return RestAxios.get(`user-web/sequencing-orders/${id}/reaction`, {
    params: {
      page: page,
      size: size,
      demoName: demoName,
      primerName: primerName,
      officialDownloadResultFlag,
      firstResultUploadTimeStart,
      firstResultUploadTimeEnd,
    }
  })
}

/**
 * 高通量-反应信息
 * @param id
 */
 export const hightOrderReaction = (id, page, size, demoName) => {
  return RestAxios.get(`user-web/high-throughput-demos`, {
    params: {
      page: page,
      size: size,
      name: demoName,
      orderId:id,
    }
  })
}

/**
 * 测序反应工单-分页列表
 */
export const sequencingWorkOrders = (page, size, orderCreateDayStart, orderCreateDayEnd, orderNo, primerName, demoName, customerId,isHis, firstResultUploadTimeStart, firstResultUploadTimeEnd,  officialDownloadResultFlag) => {
  return RestAxios.get('user-web/sequencing-reaction-work-orders', {
    params: {
      page: page,
      size: size,
      orderCreateDayStart: orderCreateDayStart,
      orderCreateDayEnd: orderCreateDayEnd,
      orderNo: orderNo,
      primerName: primerName,
      demoName: demoName,
      customerId: customerId,
      sort: 'createTime,desc',
      isHis: isHis,
      firstResultUploadTimeStart,
      firstResultUploadTimeEnd,
      officialDownloadResultFlag,
    }
  })
}

/**
 * 测序发起取样
 */
export const brindOrders = (remark, fileUrl, address, fileName) => {
  return Axios.post('web/send/bring-orders', {
    remark: remark,
    fileUrl: fileUrl,
    address: address,
    fileName: fileName
  })
}

/**
 * 测序取样查询
 * @param page
 * @param size
 */
export const bringOrdersLists = (page, size) => {
  return Axios.get('web/send/bring-orders', {
    params: {
      page: page,
      size: size,
      sort: 'createSendDate,desc'
    }
  })
}

/**
 * 保存基因订单
 * @param data
 */
export const geneOrders = (data) => {
  return RestAxios.post('user-web/gene-orders', data)
}

/**
 * 获取基因配置信息
 * @param key
 */
export const geneConfig = (key) => {
  return RestAxios.get('gene-orders/config-list', {
    params: {
      key: key
    }
  })
}
/**
 * 获取基因下单载体信息
 */
export const fetchRawCarrierList = () => {
  return Axios.get('raw-carriers/user-web')
}

/**
 * 查询订单
 */
export const geneOrdersLists = (page, size, orderNo, createDayStart, createDayEnd, status, customerId, researchTeamId) => {
  return RestAxios.get('user-web/gene-orders', {
    params: {
      page: page,
      size: size,
      no: orderNo,
      createDayStart: createDayStart,
      createDayEnd: createDayEnd,
      userWebOrderStatus: status,
      customerId: customerId,
      researchTeamId: researchTeamId,
      sort: 'createTime,desc'
    }
  })
}

/**
 * 核心系统-官网-基因合成订单
 * @param id
 */
export const geneOrdersDetails = (id) => {
  return RestAxios.get(`user-web/gene-orders/${id}`)
}

/**
 * 订单详情-包含合成基因
 * @param id
 */
export const geneWorkOrder = (id) => {
  return RestAxios.get(`user-web/gene-orders/${id}/work-order`)
}

/**
 * 配送单查询
 */
export const sendOrders = (page, size, orderCode, returnedPurchaseFlag = false) => {
  return Axios.get('web/send/send-orders', {
    params: {
      page: page,
      size: size,
      orderCode: orderCode,
      returnedPurchaseFlag
    }
  })
}

/**
 * 引物配送单查询 单独处理
 */
export const primerSendOrders = (params) => {
  return Axios.get('web/send/send-orders', {
    params
  })
}

/**
 * 查询配送单明细
 * @param sendOrderId
 */
export const sendOrdersDetails = (sendOrderId) => {
  return Axios.get(`web/send/send-orders/${sendOrderId}/items`)
}

/**
 * 测序反应工单-批量返样
 */
export const returnExample = (ids) => {
  return RestAxios.put('user-web/sequencing-demo/batch/send-order', ids)
}

/**
 * 基因订单报价
 * @returns {*}
 */
// export const genePrice = (id) => {
//   return RestAxios.push(`gene-orders/${id}/price`)
// }

/**
 * 聚合 搜索
 * @param title
 */
export const search = (keyword) => {
  return Axios.get(`web/cms/search?keyword=${keyword}`)
}

export const searchLiterature = (search,page,size) => {
  return Axios.get('/web/literature/docs',{
    params:{
      page:page,
      search:search,
      size:size
    }
  })
}

/**
 * 客户用户-测序邮件接收规则修改
 * @param rule
 */
export const userRules = (rule) => {
  return Axios.put('web/user/customer-users/change-gser-rule', {
    rule: rule
  })
}

/**
 * 引物信息上传解析
 */
export const uploadPrimer = (data) => {
  return RestAxios.post('user-web/primer-synthesis-excel', data)
}

/**
 * 文件上传
 */
export const uploadFile = () => {
  return Axios.post('file/v1')
}

/**
 * 引物订单删除
 * @param id
 */
export const delPrimerOrder = (id) => {
  return RestAxios.delete(`/user-web/primer-order/${id}`)
}

/**
 * 基因订单删除
 * @param id
 */
export const delGeneOrder = (id) => {
  return RestAxios.delete(`/user-web/gene-orders/${id}`)
}

/**
 * 测序反应工单-明细表
 * @param id
 */
export const sangerExcel = (id) => {
  return RestAxios.post(`/user-web/sequencing-orders/${id}/detail-excel`)
}

/**
 * 测序反应工单-结果文档-工单id
 * @param id
 * @param ids
 */
export const sangerWorderDoc = (ids) => {
  return RestAxios.post('/user-web/sequencing-orders/sequencing-reaction-work-orders/docs-download', ids)
}
//根据订单id
export const sangerWorderDocK = (ids) => {
  return RestAxios.post('/user-web/sequencing-orders/sequencing-reaction-work-orders/work-order-docs-download', ids)
}
//拼接文件下载
export const sangerWorderJoin = (ids) => {
  // return RestAxios.post('/user-web/sequencing-reaction-work-orders/join-download', ids)
  return RestAxios({
    url: '/user-web/sequencing-reaction-work-orders/join-download',
    method: 'post',
    data: ids,
    responseType: 'blob'
  })
}
/**
 * 高通量反应工单-结果文档
 * @param id
 * @param ids
 */
export const highOrdersWorderDocK = (params) => {
  return RestAxios.post('/user-web/high-throughput-reaction-work-orders/docs-download', params)
}
/**
 * 高通量反应工单-明细表
 * @param id
 */
 export const highOrdersExcel = (params) => {
  return RestAxios.post(`/user-web/high-throughput-reaction-work-orders/detail-excel`,params)
}
/**
 * 引物订单-导出合成报告单
 * @param id
 */
export const primerExcel = (id) => {
  return RestAxios.post(`/user-web/primer-orders/${id}/composite-report-xlsx`)
}

/**
 * 基因报价
 */
export const genePrice = (discount, geneServiceType, deliveryNumberType, data) => {
  return RestAxios.post(`/user-web/gene-price?discountCoefficient=${discount}&geneServiceType=${geneServiceType}&deliveryNumberType=${deliveryNumberType}`, data)
}

/**
 * 测序订单-结算信息
 * @param id
 */
export const sangerSettlement = (id) => {
  return RestAxios.get(`/user-web/sequencing-orders/${id}/settlement`)
}

/**
 * 测序反应工单-峰图文件
 * @param id
 */
export const peakDown = (id) => {
  return RestAxios.post(`/user-web/sequencing-reaction-work-orders/${id}/peak-download`)
}

/**
 * 查询服务订单
 */
export const coreOrders = (page, size, customerId) => {
  return Axios.get('/web/all-order-views', {
    params: {
      customerId: customerId,
      page: page,
      size: size,
      orderStatus: 'ing',
      sort: 'createTime,desc'
      // orderType: 'product_order'
    }
  })
}

// 分享无权限接口-获取分子订单详情

export const fetchNoAuthOrderDetail = id => Axios.get(`/web/product/orders/no-audit/${id}`)

// 分享无权限接口-提交分子订单
export const changeNoAuthOrderStatus = id => Axios.post(`/web/product/orders/no-audit/confirm/${id}`)

// 分享无权限接口-获取授权列表
export const fetchNoAuthGroupList = id => Axios.get(`/web/user/customer-users/no-audit/group-users?id=${id}`)

//获取授权列表
export const fetchAuthGroupList = id => Axios.get(`/web/user/customer-users/auth/group-users?id=${id}`)

// 分享无权限接口-给课题组授权
export const changeNoAuthGroupItemStatus = (id, data) => Axios.post(`/web/user/customer-users/no-audit/authorization/${id}`, data)

//给课题组授权
export const changeAuthGroupItemStatus = (id, data) => Axios.post(`/web/user/customer-users/auth/group-users/${id}`, data)


/**
 * 查询客户邮箱和手机号是否重复注册
 */
export const isEmailRepeat = (type, value) => {
  if(type==="email") return Axios.post('/web/user/customer-users/check', {email:value})
  if(type==="phone") return Axios.post('/web/user/customer-users/check', {mobilePhone:value})
}

export const loginShopDelete = (sign) => {
  return Axios.delete(`/web/user/customer-users/login/shop`,{
    data: sign,
  })
}

export const fetchRegionData = _ => get(`/address/three-level-address`)

export const fetchIsUpdateAgreement = _ => get(`/shop-article/agreement-flag`)

export const updateServiceAgreement = _ => post(`/shop-article/update/service-agreement`)

/**
 * 获取 引物三五端中间特殊单体修饰
 */
export const getSystemDictByUnitType = (params) => {
  return RestAxios.get('system/modified-primer-quote/dictByUnitType', {
    params: params
  })
}

//校验客户课题组拉黑业务线
export const blacklistsCheck = (customerId, type) => {
  return Axios.get( `/service-blacklists/check?customerId=${customerId}&type=${type}`)
}


// WEBPACK FOOTER //
// ./src/services/api.index.js